export enum AppState {
    initializing,
    loading,
    ready,
    error
}
